import React, { useState } from "react";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";

interface DialogFinalizarProcessoProps {
  open: boolean;
  handleClose: () => void;
  handleOK: (motivo: string) => void;
  isLoading: boolean;
}

export default function DialogFinalizarProcesso({
  open,
  handleClose,
  handleOK,
  isLoading
}: DialogFinalizarProcessoProps) {

  const [motivoFinalizar, setMotivoFinalizar] = useState("");
  const [error , setError] = useState(false);

  const handleCancelar = () => {
    setMotivoFinalizar("");
    handleClose();
  };

  const validarFinalizar = () => {
    if (motivoFinalizar.trim() === "") {
      setError(true);
      return false;
    }
    setError(false);
    return true;
  }

  const handleConfirmar = () => {
    if (validarFinalizar()) {
      handleOK(motivoFinalizar);
    }
  }


  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>Finalizar Processo</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" gutterBottom>
          O processo atual será finalizado.
        </Typography>

        <TextField
          required
          error={error}
          autoFocus
          margin="dense"
          id="motivo-finalizar"
          label="Motivo da finalização"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={motivoFinalizar}
          onChange={(e) => setMotivoFinalizar(e.target.value)}
          helperText={error? "Este campo é obrigatório" : ""}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancelar} color="primary">
          Cancelar
        </Button>

        <Button disabled={isLoading} variant="contained" onClick={() => handleConfirmar()} color="error">
          {isLoading && <CircularProgress size={20} sx={{ mr: 1 }} />}
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
